// extracted by mini-css-extract-plugin
export default {"seasonCount":"SeasonsCell-seasonCount-HEZS0"};